import * as React from 'react';
import { IconV2ToV3Adapter } from './adapters/IconV2ToV3Adapter/IconV2ToV3Adapter.js';

var Icon = function Icon(props) {
  return /*#__PURE__*/React.createElement(IconV2ToV3Adapter, props);
};

// We have enzyme tests on consumers that use `shallow(...).find('Icon')` function to find the Icon component in the hierarchy.
// This method looks for a displayName. So, we must set the displayName explicitly to not rewrite those tests.
// For new components though, it's better that consumers use constructors to find components (or even better to use playwright instead of enzyme).
Icon.displayName = 'Icon';

// Also needed for enzyme test snapshots
Icon.defaultProps = IconV2ToV3Adapter.defaultProps;

export { Icon };
//# sourceMappingURL=Icon.js.map
